import {PasswordResetRedeemApiInterface} from "../api/interface/password-reset-redeem";
import {PasswordResetRequestApiInterface} from "../api/interface/password-reset-request";
import type {RevaThunkAction} from "./revaHooks";

/**
 * #19351: Requests a password-reset e-mail for a login name or e-mail address. No auth state is read or
 * touched — the endpoint needs no credentials and always answers 200 (see
 * {@link PasswordResetRequestApiInterface}). Rejects with the raw `WebError` on 429/503 for the dialog to
 * render itself.
 */
export const requestPasswordResetThunk =
    (login: string): RevaThunkAction<Promise<void>> =>
    async (_dispatch, _getState, {serviceApi}) => {
        await new PasswordResetRequestApiInterface({login}).execute(serviceApi);
    };

/**
 * #19351: Redeems a password-reset token together with a new password. No auth state is read or touched.
 * Rejects with the raw `WebError` on 422/503 (see {@link PasswordResetRedeemApiInterface}).
 */
export const redeemPasswordResetThunk =
    (token: string, newPassword: string): RevaThunkAction<Promise<void>> =>
    async (_dispatch, _getState, {serviceApi}) => {
        await new PasswordResetRedeemApiInterface({token, newPassword}).execute(serviceApi);
    };
